// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__I8ANL","intro":"styles_intro__FuDVg","cardsSection":"styles_cardsSection__A_mBO"};